import type { ReactNode } from "react";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { ActionConfiguration } from "./ActionConfiguration/ActionConfiguration";
import { Link } from "react-router";
import { FoodsIcon } from "@foodpilot/foods";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { useTranslation } from "react-i18next";
import { useMyActionPlanContext } from "../context/useMyActionPlan";
import { ActionOverviewCard } from "src/components/Actions/Common/ActionOverviewCard";

export type ActionEditLayoutWithStickyInfoProps = {
    children: ReactNode;
};

export const ActionEditLayoutWithStickyInfo = (props: ActionEditLayoutWithStickyInfoProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { urls } = useActionsContext();
    const { actionPlanAction } = useMyActionPlanContext();
    const { children } = props;

    return (
        <Stack>
            <Typography variant="h2">{actionPlanAction?.action.title}</Typography>
            <Link
                to={urls.planning()}
                style={{
                    width: "fit-content",
                }}
            >
                <Button variant="text" startIcon={<FoodsIcon size={2} icon={"arrowLeft"} />}>
                    {t("actionplanaction.back_to_action_plan", "Back to my action plan")}
                </Button>
            </Link>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },
                    gap: theme.spacing(3),
                    width: "100%",
                    alignItems: "flex-start",
                }}
            >
                {/* Colonne principale (gauche sur desktop, en haut sur mobile) */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        order: {
                            xs: 1,
                            md: 1,
                        },
                    }}
                >
                    <Stack gap={theme.spacing(3)}>
                        {actionPlanAction?.action.imageUrl && (
                            <ActionOverviewCard
                                description={actionPlanAction.action.description}
                                imageUrl={actionPlanAction.action.imageUrl}
                                variant="engaged"
                            />
                        )}
                        {children}
                    </Stack>
                </Box>
                {/* Colonne sticky (droite sur desktop, en bas sur mobile) */}
                <Box
                    sx={{
                        width: {
                            xs: "100%",
                            md: "257px",
                        },
                        position: {
                            xs: "relative",
                            md: "sticky",
                        },
                        order: {
                            xs: 2,
                            md: 2,
                        },
                        top: 0,
                        height: "fit-content",
                        alignSelf: "flex-start",
                        zIndex: 1000,
                    }}
                >
                    {actionPlanAction !== undefined && <ActionConfiguration actionPlanAction={actionPlanAction} />}
                </Box>
            </Box>
        </Stack>
    );
};
